module.exports = __webpack_public_path__ + "img/qrcode-chicken-868.a49f0f11.png";